export default function createSuperTextbox(fabric: any) {
    fabric.SuperTextbox = fabric.util.createClass(fabric.Textbox, {
        corner: 0,
        initialize: function (text, options) {
            options = options || {};
            options.strokeWidth = 0;
            options.padding = 20;
            options.isComment = true;
            options.backgroundColor = '#FAFAAA';
            options.textAlign = 'left';

            if (options.corner) {
                this.corner = options.corner;
            }

            this.callSuper('initialize', text, options);
            this.createExtraGroup();

            this.setControlsVisibility({
                mt: false, // middle top
                mb: false // midle bottom
            });
        },
        _render: function (ctx) {
            this.createExtraGroup();
            this.rect.render(ctx);
            this.callSuper('_render', ctx);
        },
        createExtraGroup: function () {
            let textSquare = new fabric.Rect({
                left: -20,
                top: -20,
                height: this.height + 40,
                width: this.width + 40,
                fill: 'rgba(255,255,165,0.95)',
                stroke: 'rgba(200,180,80,0.95)',
                strokeWidth: 2
            });

            const pointerOptions = {
                fill: 'rgba(200,180,80,0.95)',
                left: -5,
                top: -5,
                originX: 'center',
                originY: 'center'
            };

            let pointer = new fabric.Path('M 0 0 L 30 0 L 0 30 z'); // rightLeft

            if (this.corner === 1) {
                // rightTop
                pointer = new fabric.Path('M 30 0 L 30 30 L 0 0 z');
                pointerOptions.left = this.width + 5;
            } else if (this.corner === 2) {
                // rightBottom
                pointer = new fabric.Path('M 30 0 L 30 30 L 0 30 z');
                pointerOptions.left = this.width + 5;
                pointerOptions.top = this.height + 5;
            } else if (this.corner === 3) {
                // leftBottom
                pointer = new fabric.Path('M 0 0 L 30 30 L 0 30 z');
                pointerOptions.top = this.height + 5;
            }

            pointer.set(pointerOptions);

            this.rect = new fabric.Group([textSquare, pointer], {
                left: -this.width / 2 - 20,
                top: -this.height / 2 - 20
            });
        },
        toggleCorner: function () {
            this.dirty = true;
            this.corner = this.corner === 3 ? 0 : this.corner + 1;
        }
    });

    fabric.SuperTextbox.fromObject = function (options, callback) {
        let obj = new fabric.SuperTextbox(options.text, {
            left: options.left,
            top: options.top,
            width: options.width,
            fontSize: options.fontSize,
            fontFamily: options.fontFamily
        });

        if (callback) {
            callback(obj);
        }

        return obj;
    };
}
